import { useContext, createContext } from 'react';

export const ChartContext = createContext(null);

export function useChartContext() {
  return useContext(ChartContext);
}

export default ChartContext;
